import { render, staticRenderFns } from "./CategoryHeader.vue?vue&type=template&id=99b0021c&scoped=true"
import script from "./CategoryHeader.vue?vue&type=script&lang=ts"
export * from "./CategoryHeader.vue?vue&type=script&lang=ts"
import style0 from "./CategoryHeader.vue?vue&type=style&index=0&id=99b0021c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b0021c",
  null
  
)

export default component.exports